import styled from '@emotion/styled';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

import { Button } from '../../../../../../../Button/Button';

export const StyledForm = styled.form`
  display: flex;
  gap: var(--spacing-8);
`;

export const TextArea = styled(TextareaAutosize)`
  resize: none;
  width: 100%;
  border-radius: var(--border-radius-m);
  border-color: var(--color-secondary-80);
  padding: var(--spacing-12) var(--spacing-16);
  font: var(--font-body-l-light);

  &:focus {
    outline: none;
    border-color: var(--color-secondary-70);
  }
`;

export const SendButton = styled(Button)`
  padding-inline: var(--spacing-12);
`;
